/**
 * Configuración económica — Web App.
 * Mantener sincronizado con common/src/config/economyConfig.js
 */
export const ENABLE_GOOGLE_ROUTES = false;
export const ENABLE_DISTANCE_MATRIX = false;
export const ENABLE_COMPUTE_ROUTE_MATRIX = false;
export const ENABLE_DEBUG_LOGS = false;
export const MAX_ROUTE_CALLS_PER_SESSION = 3;
export const MAX_NEARBY_DRIVERS = 10;
export const MAX_INITIAL_DISPATCH_DRIVERS = 10;
export const PLACES_MIN_CHARS = 3;
export const PLACES_DEBOUNCE_MS = 800;
export const GEOCODING_DEBOUNCE_MS = 1000;
export const MAX_FIRESTORE_LIST_LIMIT = 20;
export const MAX_BOOKING_HISTORY_LIMIT = 30;
export const ADMIN_BOOKING_FETCH_LIMIT = 300;
export const ADMIN_USERS_PAGE_SIZE = 50;

export default {
    ENABLE_GOOGLE_ROUTES,
    ENABLE_DISTANCE_MATRIX,
    ENABLE_COMPUTE_ROUTE_MATRIX,
    ENABLE_DEBUG_LOGS,
    MAX_ROUTE_CALLS_PER_SESSION,
    MAX_NEARBY_DRIVERS,
    MAX_INITIAL_DISPATCH_DRIVERS,
    PLACES_MIN_CHARS,
    PLACES_DEBOUNCE_MS,
    GEOCODING_DEBOUNCE_MS,
    MAX_FIRESTORE_LIST_LIMIT,
    MAX_BOOKING_HISTORY_LIMIT,
    ADMIN_BOOKING_FETCH_LIMIT,
    ADMIN_USERS_PAGE_SIZE,
};
